<script lang="ts">
	import DayBackgroundHelper from './DayBackgroundHelper.svelte'
	import { DateTime } from 'luxon'
	import { createEventDispatcher } from 'svelte'

	interface Props {
		day: DateTime
		index: number
		start?: DateTime
		end?: DateTime
		imaginaryEnd?: DateTime
	}

	let { day, index, start = null, end = null, imaginaryEnd = null }: Props = $props()

	const dispatch = createEventDispatcher()

	function handleSelectImaginaryEnd(day: DateTime) {
		dispatch('selectImaginaryEnd', day)
	}

	function handleSelect(day: DateTime) {
		dispatch('select', day)
	}

	let isStart = $derived(start && day.hasSame(start, 'day'))
	let isEnd = $derived(end && day.hasSame(end, 'day'))
	let isImaginaryEnd = $derived(imaginaryEnd && day.hasSame(imaginaryEnd, 'day'))

	let isImaginarySelectInPast = $derived(imaginaryEnd < start)

	let isBetween = $derived(
		start &&
			end &&
			day.startOf('day') > start.startOf('day') &&
			day.startOf('day') < end.startOf('day'),
	)
	let isBetweenImaginary = $derived(
		start &&
			imaginaryEnd &&
			((day.startOf('day') > start.startOf('day') &&
				day.startOf('day') < imaginaryEnd.startOf('day')) ||
				(day.startOf('day') < start.startOf('day') &&
					day.startOf('day') > imaginaryEnd.startOf('day'))),
	)
	let isCurrent = $derived(day.hasSame(DateTime.now(), 'day'))

	let isFirst = $derived(index === 0)
	let isLast = $derived(index === 6)

	let isFirstInMonth = $derived(day.hasSame(day.startOf('month'), 'day'))
	let isLastInMonth = $derived(day.hasSame(day.endOf('month'), 'day'))

	let isOnEdge = $derived(isFirst || isLast || isFirstInMonth || isLastInMonth)

	let isRangeSameDay = $derived(start && end && start.hasSame(end, 'day'))
</script>

<button
	class="
    group relative flex w-full justify-center text-center
    {isBetween && !isOnEdge ? 'bg-primary-100 dark:bg-primary-900' : ''}
    {isBetweenImaginary && !isOnEdge ? 'bg-gray-200 dark:bg-gray-500' : ''}
  "
	onclick={() => handleSelect(day)}
	onmouseenter={() => handleSelectImaginaryEnd(day)}
	type="button"
>
	{#if isBetweenImaginary || (imaginaryEnd && isStart) || isImaginaryEnd}
		<DayBackgroundHelper
			class="bg-gray-200 dark:bg-gray-500"
			isEnd={isImaginarySelectInPast ? isStart : isImaginaryEnd}
			{isFirst}
			{isFirstInMonth}
			{isLast}
			{isLastInMonth}
			isStart={isImaginarySelectInPast ? isImaginaryEnd : isStart}
		/>
	{:else if (isBetween || isStart || isEnd) && start && end && !isRangeSameDay}
		<DayBackgroundHelper
			class="bg-primary-100 dark:bg-primary-900"
			{isEnd}
			{isFirst}
			{isFirstInMonth}
			{isLast}
			{isLastInMonth}
			{isStart}
		/>
	{/if}
	<div
		class="
        group-hover:bg-primary-50 dark:group-hover:bg-primary-900 relative flex h-8 w-8 items-center
        justify-center rounded-full group-hover:text-gray-600 dark:group-hover:text-gray-200
        {isStart || isEnd
			? 'bg-primary-500 text-white'
			: isBetweenImaginary || isImaginaryEnd
				? 'bg-gray-200 dark:bg-gray-500'
				: isBetween
					? 'bg-primary-100 dark:bg-primary-900'
					: ''}
        {isCurrent ? 'border border-gray-500' : ''}
      "
	>
		{day.toFormat('d')}
	</div>
</button>
